import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStarLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 2.25a.75.75 0 0 1 .664.4l1.854 3.525a1.1 1.1 0 0 0 .798.586l.018.003 3.81.747a.75.75 0 0 1 .43 1.22l-2.635 3.128a1.1 1.1 0 0 0-.3.894v.002l.505 4.047a.75.75 0 0 1-1.049.778l-3.59-1.595-.042-.02A1 1 0 0 0 10 15.85a1.25 1.25 0 0 0-.54.125l-3.509 1.7a.75.75 0 0 1-1.071-.767l.506-4.099a1.1 1.1 0 0 0-.301-.9l-2.66-3.18a.75.75 0 0 1 .43-1.218l3.81-.747.018-.003a1.12 1.12 0 0 0 .8-.586l.004-.01 1.85-3.514A.75.75 0 0 1 10 2.25M8.043 7.77c.325-.24.59-.55.774-.91Zm.774-.91L10 4.611l1.183 2.249a2.6 2.6 0 0 0 1.871 1.378l2.552.5-1.806 2.144a2.6 2.6 0 0 0-.65 2.051v.004l.341 2.734-2.357-1.048a2.5 2.5 0 0 0-1.132-.273H10a2.75 2.75 0 0 0-1.194.275l-2.268 1.099.337-2.732a2.6 2.6 0 0 0-.648-2.057L4.389 8.74l2.557-.501c.397-.07.772-.23 1.097-.468"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStarLine;
